import moment from 'moment'
import _ from 'lodash'
import {
  numeroBagni,
  numeroPostiLetto,
  numeroCamereLetto,
  numeroCoinquilini,
  extra,
  caparre,
  disdette,
  permanenze,
  orariPrenotazione,
} from '../assets/constants'

const types = [
  'Studio',
  'Entire Property',
  'Private Room',
  'Shared Room',
  'Loft',
  'Villa',
]

const gender = (value) => {
  switch (value) {
    case 'M':
      return 'Male'
    case 'F':
      return 'Female'
    case 'U':
      return 'Any'
  }
}

const deposits = (value) => {
  switch (value) {
    case '1 Month':
      return _.get(caparre, '[0].value')
    case '2 Months':
      return _.get(caparre, '[1].value')
    case '3 Months':
      return _.get(caparre, '[2].value')
    case '0.5 Month':
      return _.get(caparre, '[3].value')
    case 'No Deposit':
      return _.get(caparre, '[3].value')
  }
}

const reverseGender = (value) => {
  switch (value) {
    case 'Male':
      return 'M'
    case 'Female':
      return 'F'
    case 'Any':
      return 'U'
  }
}

const furniture = (value) => {
  const _furniture = []
  _.each(value, (item) => {
    switch (item) {
      case 'lavatrice':
        _furniture.push('Lavatrice')
        break
      case 'lavastoviglie':
        _furniture.push('Lavastoviglie')
        break
      case 'internet':
        _furniture.push('Wifi')
        break
      case 'aria_condizionata':
        _furniture.push('Aria condizionata')
        break
      case 'tv':
        _furniture.push('TV')
        break
      case 'microonde':
        _furniture.push('Microonde')
        break
      case 'armadio':
        _furniture.push('Armadio')
        break
      case 'scrivania':
        _furniture.push('Scrivania')
        break
      case 'matrimoniale':
        _furniture.push('Matrimoniale')
        break
      case 'forno':
        _furniture.push('Forno')
        break
    }
  })
  return _.size(_furniture) > 0 ? _furniture : undefined
}

const reverseFurniture = (value) => {
  const _furniture = []
  _.each(value, (item) => {
    switch (item.name) {
      case 'Lavatrice':
        _furniture.push('lavatrice')
        break
      case 'Lavastoviglie':
        _furniture.push('lavastoviglie')
        break
      case 'Wifi':
        _furniture.push('internet')
        break
      case 'Aria condizionata':
        _furniture.push('aria_condizionata')
        break
      case 'TV':
        _furniture.push('tv')
        break
      case 'Microonde':
        _furniture.push('microonde')
        break
      case 'Armadio':
        _furniture.push('armadio')
        break
      case 'Scrivania':
        _furniture.push('scrivania')
        break
      case 'Matrimoniale':
        _furniture.push('matrimoniale')
        break
      case 'Forno':
        _furniture.push('forno')
        break
    }
  })
  return _.size(_furniture) > 0 ? _furniture : undefined
}

const reverseSpese = (values) => {
  const spese = []
  _.each(values, (value, index) => {
    if (value) {
      spese.push(index)
    }
  })
  return spese
}

export const booking3d = (form) => {
  if (!form.prenotazioneData || !form.prenotazioneOrario) {
    return undefined
  }
  const booking3d = moment(form.prenotazioneData)
    .set({
      hours: form.prenotazioneOrario,
      minutes: 0,
      seconds: 0,
      milliseconds: 0,
    })
    .format()
  return booking3d
}

const fields = [
  {
    field: 'id',
    prop: 'id',
  },
  {
    field: 'latitude',
    prop: 'lat',
  },
  {
    field: 'longitude',
    prop: 'lng',
  },
  {
    field: 'name',
    prop: (form) =>
      form.indirizzo && form.citta
        ? `${form.indirizzo}, ${form.citta}`
        : undefined,
  },
  {
    field: 'short_desc',
    prop: 'titolo',
  },
  {
    field: 'type',
    prop: (form) => _.get(types, `[${form.tipologia}]`),
    draft: (draft) => ({
      tipologia: draft.type ? String(_.indexOf(types, draft.type)) : undefined,
    }),
  },
  {
    field: 'bathroom_type',
    prop: (form) => (form.tipoBagno === '0' ? 'Private' : 'Shared'),
    draft: (draft) => ({
      tipoBagno: draft.bathroom_type === 'Private' ? '0' : '1',
    }),
  },
  {
    field: 'total_house_mates',
    prop: 'numeroCoinquilini',
    draft: (draft) => ({
      numeroCoinquilini: _.get(
        _.find(
          numeroCoinquilini,
          (item) => item.value === String(draft.total_house_mates)
        ),
        'value',
        undefined
      ),
    }),
  },
  {
    field: 'house_for',
    prop: (form) => gender(form.sesso),
    draft: (draft) => ({
      sesso: reverseGender(draft.house_for),
    }),
  },
  {
    field: 'floors',
    prop: 'piano',
  },
  {
    field: 'total_bedrooms',
    prop: 'numeroCamereLetto',
    draft: (draft) => ({
      numeroCamereLetto: _.get(
        _.find(
          numeroCamereLetto,
          (item) => item.value === String(draft.total_bedrooms)
        ),
        'value'
      ),
    }),
  },
  {
    field: 'bathrooms',
    prop: 'numeroBagni',
    draft: (draft) => ({
      numeroBagni: _.get(
        _.find(numeroBagni, (item) => item.value === String(draft.bathrooms)),
        'value'
      ),
    }),
  },
  {
    field: 'no_of_beds',
    prop: 'numeroPostiLetto',
    draft: (draft) => ({
      numeroPostiLetto: _.get(
        _.find(
          numeroPostiLetto,
          (item) => item.value === String(draft.no_of_beds)
        ),
        'value'
      ),
    }),
  },
  {
    field: 'heating_system',
    prop: 'riscaldamento',
  },
  {
    field: 'address',
    prop: (form) =>
      `${form.indirizzo}, ${form.citta}${form.CAP ? ` - ${form.CAP}` : ''}`,
    draft: (draft) => ({
      indirizzo: _.get(_.split(draft.address, ', '), '[0]'),
      citta: _.get(
        _.split(_.get(_.split(draft.address, ', '), '[1]'), ' - '),
        '[0]'
      ),
      CAP: _.get(
        _.split(_.get(_.split(draft.address, ', '), '[1]'), ' - '),
        '[1]'
      ),
    }),
  },
  {
    field: 'street',
    prop: (form) => (form.strada ? form.strada : undefined),
  },
  {
    field: 'street_number',
    prop: (form) => (form.numeroCivico ? form.numeroCivico : undefined),
  },
  {
    field: 'cap',
    prop: (form) => (form.CAP ? form.CAP : undefined),
  },
  {
    field: 'city',
    prop: (form) => (form.citta ? form.citta : undefined),
  },
  {
    field: 'province',
    prop: (form) => (form.provincia ? form.provincia : undefined),
    draft: (draft) => ({ province: draft.province }),
  },
  {
    field: 'region',
    prop: (form) => (form.regione ? form.regione : undefined),
  },
  {
    field: 'country',
    prop: (form) => (form.country ? form.country : undefined),
  },
  {
    field: 'house_no',
    prop: '',
  },
  {
    field: 'property_main_image',
    prop: (form) =>
      _.get(form, 'images.[0]')
        ? _.get(form.images, '[0].draftImage', _.get(form.images, '[0]'))
        : undefined,
  },
  {
    field: 'property_more_images',
    prop: (form) =>
      _.size(_.map(_.slice(form.images, 1), (image) => image)) > 0
        ? _.map(_.slice(form.images, 1), (image) =>
            _.get(image, 'draftImage', image)
          )
        : undefined,
  },
  {
    field: 'prenotazioneOrario',
    prop: 'prenotazioneOrario',
    draft: (draft) => ({
      prenotazioneOrario: _.get(
        _.find(
          orariPrenotazione,
          (item) => item.value === String(draft.prenotazioneOrario)
        ),
        'value'
      ),
    }),
  },
  {
    field: 'prenotazioneData',
    prop: 'prenotazioneData',
    draft: (draft) => ({
      prenotazioneData: moment(draft.prenotazioneData).isValid()
        ? moment(draft.prenotazioneData)
        : undefined,
    }),
  },
  {
    field: 'start_date',
    prop: (form) => moment(form.libero).toISOString(true),
    draft: (draft) => ({
      libero: moment(draft.start_date).isValid()
        ? moment(draft.start_date)
        : undefined,
    }),
  },
  {
    field: 'end_date',
    prop: (form) => undefined,
  },
  {
    field: 'availability',
    prop: () => 'on',
  },
  {
    field: 'min_stay',
    prop: 'permanenza',
    draft: (draft) => {
      if (draft.min_stay) {
        return {
          permanenza: _.get(
            _.find(permanenze, (item) => item.value === String(draft.min_stay)),
            'value'
          ),
        }
      }
    },
  },
  {
    field: 'price',
    prop: (form) =>
      form.canone
        ? _.replace(_.split(form.canone, ' ').pop(), /[.,]/g, '')
        : undefined,
    draft: (draft) => ({
      canone: draft.price ? String(draft.price) : undefined,
    }),
  },
  {
    field: 'deposit',
    prop: 'caparre',
    draft: (draft) => ({
      caparre: deposits(draft.deposit),
    }),
  },
  {
    field: 'water',
    prop: (form) => (!_.includes(form.spese, 'acqua') ? 'on' : 'off'),
  },
  {
    field: 'gas',
    prop: (form) => (!_.includes(form.spese, 'gas') ? 'on' : 'off'),
  },
  {
    field: 'electricity',
    prop: (form) => (!_.includes(form.spese, 'elettricita') ? 'on' : 'off'),
  },
  {
    field: 'garbage',
    prop: (form) => (!_.includes(form.spese, 'rifiuti') ? 'on' : 'off'),
  },
  {
    field: 'internet',
    prop: (form) => (!_.includes(form.spese, 'internet') ? 'on' : 'off'),
  },
  {
    field: 'condominio',
    prop: (form) => (!_.includes(form.spese, 'condominio') ? 'on' : 'off'),
  },
  {
    field: 'total_cost',
    prop: (form) =>
      form.costoSpeseNonIncluse
        ? _.replace(_.split(form.costoSpeseNonIncluse, ' ').pop(), /[.,]/g, '')
        : null,
    draft: (draft) => ({
      costoSpeseNonIncluse: draft.total_cost
        ? String(draft.total_cost)
        : undefined,
    }),
  },
  {
    field: 'property_furniture',
    prop: (form) => furniture(form.furniture),
    draft: (draft) => ({
      furniture: reverseFurniture(draft.furnitures),
    }),
  },
  {
    field: 'prop_extra_info',
    prop: 'descrizione',
  },
  {
    field: 'canc_rules',
    prop: 'disdette',
    draft: (draft) => ({
      disdette: _.get(
        _.find(disdette, (item) => item.value === String(draft.canc_rules)),
        'value'
      ),
    }),
  },
  {
    field: 'refunded',
    prop: 'refunded',
  },
  {
    field: 'pets_allowed',
    prop: (form) => (form.animali ? 'on' : 'off'),
    draft: (draft) => ({
      animali: draft.pets_allowed === 'on' ? 1 : 0,
    }),
  },
  {
    field: 'stay_type',
    prop: () => 'Limitless',
  },
  {
    field: 'garden',
    prop: (form) => (_.includes(form.extra, 'giardino') ? 'on' : 'off'),
  },
  {
    field: 'balcony_terrace',
    prop: (form) => (_.includes(form.extra, 'balcone') ? 'on' : 'off'),
  },
  {
    field: 'size',
    prop: ({ size = '' }) => size.split(' ')[0],
    draft: (draft) => ({ size: `${draft.size}` }),
  },
  {
    field: 'car_parking',
    prop: (form) => (_.includes(form.extra, 'auto') ? 'included' : 'no'),
  },
  {
    field: 'living_room',
    prop: (form) => (_.includes(form.extra, 'soggiorno') ? 'on' : 'off'),
  },
  {
    field: 'with_insurance',
    prop: 'with_insurance',
  },
  {
    field: 'elevator',
    prop: (form) => (_.includes(form.extra, 'ascensore') ? 'on' : null),
  },
  {
    field: 'building_floors',
    prop: 'building_floors',
  },
  {
    field: 'booking_3d',
    prop: (form) => booking3d(form),
    draft: (draft) => ({
      prenotazioneOrario: moment(draft.booking_3d).isValid()
        ? _.get(
            _.find(
              orariPrenotazione,
              (item) => item.value === moment(draft.booking_3d).format('H')
            ),
            'value'
          )
        : undefined,
      prenotazioneData: moment(draft.booking_3d).isValid()
        ? draft.booking_3d
        : undefined,
    }),
  },
]

const reverseExtra = (draft) => {
  const extraSelected = []
  _.each(extra, (extraItem) => {
    switch (extraItem.value) {
      case 'auto':
        if (draft[extraItem.draft] === 'Included') {
          extraSelected.push(extraItem.value)
        }
        break
      default:
        if (draft[extraItem.draft] === 'on') extraSelected.push(extraItem.value)
    }
  })
  return extraSelected
}

export const getAnnuncio = (props) => {
  const annuncio = {}
  _.each(fields, (field) => {
    if (typeof field.prop === 'function') {
      annuncio[field.field] = field.prop(props.formValue)
    } else {
      annuncio[field.field] = props.formValue[field.prop]
    }
  })
  return annuncio
}

export const buildPropertyFromDraft = (draft) => {
  let property = {}
  for (const index in fields) {
    const field = fields[index]
    if (typeof field.draft === 'function') {
      const value = field.draft(draft)
      if (value) {
        property = {
          ...property,
          ...value,
        }
      }
    } else if (typeof field.prop === 'string') {
      const value = _.get(draft, `${field.field}`)
      if (value) {
        property[field.prop] = value
      }
    }
  }
  property.extra = reverseExtra(draft)
  property.spese = reverseSpese({
    acqua: draft.water === 'off',
    gas: draft.gas === 'off',
    elettricita: draft.electricity === 'off',
    rifiuti: draft.garbage === 'off',
    internet: draft.internet === 'off',
    condominio: draft.condominio === 'off',
  })
  property.nome = `${_.get(draft.owner, 'first_name', '')} ${_.get(
    draft.owner,
    'last_name',
    ''
  )}`
  property.telefono = draft.owner.phone_no
  property.images = []
  if (draft.main_image !== null) {
    property.images.push({
      visualizationImage: draft.img_desktop_search,
      draftImage: draft.main_image,
    })
  }
  property.images = [
    ...property.images,
    ..._.chain(draft.images)
      .filter((image) => !!image.img_desktop_search)
      .map((image) => ({
        visualizationImage: image.img_desktop_search,
        draftImage: image.name,
      }))
      .value(),
  ]
  property.tipoPagamento = _.toInteger(draft.total_cost) > 0 ? 0 : 1
  property.feePercentage = draft.feePercentage
  property.firstMonthFeePercentage = draft.firstMonthFeePercentage
  property.withInsuranceFeePercentage = draft.withInsuranceFeePercentage
  property.with_insurance = !!draft.with_insurance

  return property
}
